const Highcharts = require('highcharts');

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/stock')(Highcharts);
require('highcharts/modules/annotations')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);

export default class StockChart {
    constructor(el) {
        if (!this.set(el)) return;

        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.wrapper = this.root.querySelector('[data-stock-chart-wrapper]');
        this.loader = this.root.querySelector('[data-stock-chart-loader]');

        this.data = [];
        this.data_wig = [];
        this.data_wig_20 = [];
        this.data_wig_budow = [];

        this.i18n = JSON.parse(this.root.getAttribute('data-stock-chart-i18n'));
        this.chart = null;

        this.optionButtons = this.root.querySelectorAll(
            '[data-stock-chart-option]'
        );

        return true;
    }

    async init() {
        if (!this.data) return;

        await this.loadChartData();
        this.loader.classList.add('d-none');

        this.setChart();
        this.setOptionButtons();
    }

    async loadChartData() {
        const data = new FormData();
        data.append('action', 'get_stock_chart');

        try {
            this.loader.classList.remove('d-none');

            const response = await fetch(ajax.url, {
                body: data,
                method: 'POST',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const responseData = await response.json();
            const { budimex_stock, wig_stock, wig_20_stock, wig_budow_stock } =
                responseData;

            this.data = budimex_stock;
            this.data_wig = wig_stock;
            this.data_wig_20 = wig_20_stock;
            this.data_wig_budow = wig_budow_stock;
        } catch (error) {
            console.error(error);
        }
    }

    setChart() {
        Highcharts.setOptions({
            lang: this.i18n,
        });

        this.chartOptions = {
            chart: {
                styledMode: false,
            },
            rangeSelector: {
                enabled: false,
            },
            xAxis: {
                gapGridLineWidth: 0,
                type: 'datetime',
            },
            plotOptions: {
                series: {
                    pointStart: Date.UTC(2022, 11, 29),
                    pointInterval: 24 * 3600 * 1000,
                },
            },
            yAxis: {
                opposite: false,
                labels: {
                    align: 'right',
                    x: 0,
                },
            },
            navigation: {
                bindings: {},
            },
            scrollbar: {
                enabled: false,
            },
            navigator: {
                enabled: false,
            },
            exporting: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            tooltip: {
                useHTML: true,
                headerFormat: '',
                pointFormat: `<div class="highchart-tooltip">
                    <div class="highchart-tooltip__stat">
                        <p class="highchart-tooltip__date typo-14">{point.key}</p>
                    </div>
                    <div class="highchart-tooltip__stat">
                        <span class="highchart-tooltip__text typo-18">${this.i18n.texts.exchange ?? 'Kurs'}</span>
                        <span class="highchart-tooltip__value typo-19 f-700">{point.y:.2f} PLN</span>
                    </div>
                </div>`,
                shadow: false,
                borderColor: null,
                backgroundColor: null,
                borderWidth: 0,
                split: false,
            },
            series: [
                {
                    lineColor: '#EBB700',
                    lineWidth: 2,
                    color: '#EBB700',
                    visible: true,
                    type: 'area',
                    name: 'Budimex',
                    data: this.data,
                    tooltip: {
                        valueDecimals: 2,
                    },
                    fillColor: {
                        linearGradient: [0, 0, 0, 300],
                        stops: [
                            [0, 'rgba(235, 183, 0, 0.24)'],
                            [1, 'rgba(235, 183, 0, 0.1)'],
                        ],
                    },
                    threshold: null,
                },
                {
                    lineColor: '#7A99AC',
                    lineWidth: 2,
                    color: '#7A99AC',
                    visible: false,
                    type: 'area',
                    name: 'WIG',
                    data: this.data_wig,
                    gapSize: 5,
                    tooltip: {
                        valueDecimals: 2,
                    },
                    fillColor: {
                        linearGradient: [0, 0, 0, 300],
                        stops: [
                            [0, 'rgba(122, 153, 172, 0.24)'],
                            [1, 'rgba(122, 153, 172, 0.1)'],
                        ],
                    },
                    threshold: null,
                },
                {
                    lineColor: '#98BE6B',
                    lineWidth: 2,
                    color: '#98BE6B',
                    visible: false,
                    type: 'area',
                    name: 'WIG-BUDOW',
                    data: this.data_wig_budow,
                    gapSize: 5,
                    tooltip: {
                        valueDecimals: 2,
                    },
                    fillColor: {
                        linearGradient: [0, 0, 0, 300],
                        stops: [
                            [0, 'rgba(152, 190, 107, 0.24)'],
                            [1, 'rgba(152, 190, 107, 0.1)'],
                        ],
                    },
                    threshold: null,
                },
                {
                    lineColor: '#617FBD',
                    lineWidth: 2,
                    color: '#617FBD',
                    visible: false,
                    type: 'area',
                    name: 'WIG20',
                    data: this.data_wig_20,
                    gapSize: 5,
                    tooltip: {
                        valueDecimals: 2,
                    },
                    fillColor: {
                        linearGradient: [0, 0, 0, 300],
                        stops: [
                            [0, 'rgba(39, 87, 148, 0.24)'],
                            [1, 'rgba(39, 87, 148, 0.1)'],
                        ],
                    },
                    threshold: null,
                },
            ],
        };

        this.chart = Highcharts.stockChart(this.wrapper, this.chartOptions);
    }

    setOptionButtons() {
        if (!this.optionButtons) return;

        this.onOptionButton = this.onOption.bind(this);
        this.optionButtons.forEach(item => {
            item.addEventListener('click', event => this.onOptionButton(event));
        });
    }

    onOption(event) {
        const { currentTarget } = event;
        if (!currentTarget) return;

        const option = currentTarget.getAttribute('data-stock-chart-option');

        this.resetOptions();
        this.switchOption(option);

        currentTarget.classList.add('active');
    }

    resetOptions() {
        if (!this.optionButtons) return;
        this.optionButtons.forEach(item => item.classList.remove('active'));
    }

    switchOption(option) {
        const d = new Date();
        const currDay = d.getDate();
        const currMonth = d.getMonth();
        const currYear = d.getFullYear();

        switch (option) {
            case 'd1':
                this.chart.xAxis[0].setExtremes(
                    Date.UTC(currYear, currMonth, currDay),
                    Date.UTC(currYear, currMonth, currDay)
                );
                break;
            case 'w1':
                this.chart.xAxis[0].setExtremes(
                    Date.UTC(currYear, currMonth, currDay - 7),
                    Date.UTC(currYear, currMonth, currDay)
                );
                break;
            case 'm1':
                this.chart.xAxis[0].setExtremes(
                    Date.UTC(currYear, currMonth - 1, currDay),
                    Date.UTC(currYear, currMonth, currDay)
                );
                break;
            case 'm3':
                this.chart.xAxis[0].setExtremes(
                    Date.UTC(currYear, currMonth - 3, currDay),
                    Date.UTC(currYear, currMonth, currDay)
                );
                break;
            case 'm6':
                this.chart.xAxis[0].setExtremes(
                    Date.UTC(currYear, currMonth - 6, currDay),
                    Date.UTC(currYear, currMonth, currDay)
                );
                break;
            case 'm12':
                this.chart.xAxis[0].setExtremes(
                    Date.UTC(currYear, currMonth - 12, currDay),
                    Date.UTC(currYear, currMonth, currDay)
                );
                break;
            case 'all':
                this.chart.xAxis[0].setExtremes(
                    Date.UTC(1995, 0, 1),
                    Date.UTC(currYear, currMonth, 31)
                );
                break;
            default:
                break;
        }
    }

    setActiveGroup(chart_index) {
        const visibleSeries = this.chart.series.filter((item, index) => {
            return item.visible;
        });

        this.chart.series.forEach((item, index) => {
            let itemVisible = item.visible;
            let newVisible = !itemVisible;

            if (chart_index === index) {
                item.setVisible(newVisible, false);

                if (visibleSeries.length === 1 && newVisible === false)
                    item.setVisible(true, false);
            }
        });

        this.chart.redraw();
    }
}
